import { motion, useInView } from "framer-motion";
import { useRef, useState } from "react";
import Navbar from "../../components/HomeLandingPage/Home/NavBar/Navbar";
import WhyChooseQuikTix from "../../components/HomeLandingPage/Home/WhyChooseTix/WhyQuickTix";
import FeaturedEvents from "../../components/HomeLandingPage/Home/FeaturedEvents/FeaturedEvents";
import AffordablePricing from "../../components/HomeLandingPage/Home/AffordablePricing/AffordablePricing";
import Experience from "../../components/HomeLandingPage/Home/Experience";

import TestimonialsPage from "../../components/HomeLandingPage/Home/Testimonials/Testimonials";
import TestimonialsPage2 from "../../components/HomeLandingPage/Home/Testimonials/Testimonials2";
import PricingPage from "../../components/HomeLandingPage/Home/Pricing/PricingPage";
import PromotionPage from "../../components/HomeLandingPage/Home/Promotion/PromotionPage";
import Footer from "../../components/HomeLandingPage/Home/Footer/Footer";
import DiscoverPage from "../../components/HomeLandingPage/Home/Discover/DiscoverPage";
import SmartFeatures from "../../components/HomeLandingPage/Home/SeamlessTicketing/SeamlessTicketing";
import AnalyticsInsights from "../../components/HomeLandingPage/Home/AnalyticsAndInsights/AnalyticsInsights";
import ManageEventsOnGo from "../../components/HomeLandingPage/Home/ManageEventsOnGo/ManageEventsOnGo";
import { Box, Container, Stack } from "@mui/material";
import { Button } from "antd";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { useNavigate } from "react-router-dom";
import HassleFreeApproach from "../../components/HomeLandingPage/Home/HassleFreeApproach/HassleFreeApproach";

const sectionVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const AnimatedSection = ({ children }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false });

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={sectionVariants}
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
};

const HomePage = () => {
  const navigate = useNavigate();
  return (
    <>
      <AnimatedSection>
        <Box
          sx={{
            paddingLeft: "25px",
            paddingRight: "25px",
            boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
          }}
        >
          <Navbar />
        </Box>
      </AnimatedSection>

      <AnimatedSection>
        <DiscoverPage />
      </AnimatedSection>

      {/* Create and Manage Events on the Go */}
      {/* <AnimatedSection>
      <Box sx={{ mt: { xs: 10, md: 20 } }}>
        <ManageEventsOnGo />
        </Box>
      </AnimatedSection> */}

      <AnimatedSection>
        <Box sx={{ mt: { xs: 10, md: 20 } }}>
          <FeaturedEvents />
        </Box>
      </AnimatedSection>

      {/* Analytics and Insights */}
        <AnimatedSection>
        <Box sx={{ mt: { xs: 10, md: 20 } }}>
          <AnalyticsInsights />
          </Box>
        </AnimatedSection>

      <AnimatedSection>
        <Box sx={{ mt: { xs: 10, md: 20 } }}>
          <SmartFeatures />
        </Box>
      </AnimatedSection>


      <AnimatedSection>
        <Box sx={{ mt: { xs: 10, md: 20 } }}>
          <HassleFreeApproach />
        </Box>
      </AnimatedSection>

      <AnimatedSection>
        <Box sx={{ mt: { xs: 10, md: 20 } }}>
          <WhyChooseQuikTix />
        </Box>
      </AnimatedSection>
      
      {/* <AnimatedSection>
        <Box sx={{ mt: { xs: 10, md: 20 } }}>
          <PromotionPage />
        </Box>
      </AnimatedSection> */}

     
      {/* <AnimatedSection>
        <Box sx={{ mt: { xs: 10, md: 20 } }}>
          <AffordablePricing />
        </Box>
      </AnimatedSection> */}

      <AnimatedSection>
        <Box sx={{ mt: { xs: 10, md: 20 } }}>
          <TestimonialsPage />
        </Box>
      </AnimatedSection>
      {/*  <AnimatedSection>
        <Box sx={{ mt: { xs: 10, md: 20 } }}>
          <TestimonialsPage2 />
        </Box>
      </AnimatedSection> */}
      
      <AnimatedSection>
        <Box
          sx={{ mt: { xs: 10, md: 20 }, display: { xs: "none", sm: "block" } }}
        >
          <Experience />
        </Box>
      </AnimatedSection>
      <AnimatedSection>
        <Box sx={{ mt: { xs: 10, md: 20 } }}>
          <Footer />
        </Box>
      </AnimatedSection>
    </>
  );
};

export default HomePage;
